import { CounselingCategory } from "@src/api/expert/expertApi";

export const CHECK_TEXT: Record<CounselingCategory, string> = {
    중개: "공인중개사로 등록할래요",
    매물컨설팅: "경매물건 컨설팅 전문가로 등록할래요",
    매수신청대리인: "매수신청대리인으로 등록할래요",
    임장동행: "임장동행 전문가로 등록할래요",
};

export function isEqualSet<T>(a?: Set<T>, b?: Set<T>) {
    if (!a && !b) return true;
    if (!a || !b) return false;
    if (a.size !== b.size) return false;
    const aArray = Array.from(a);
    for (let i = 0; i < aArray.length; i++) {
        if (!b.has(aArray[i])) return false;
    }
    return true;
}

export function createId() {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
        return crypto.randomUUID();
    }
    return Math.random().toString(36).slice(2, 10);
}

export type PreviewItem = { id: string; url: string };
